import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

const navItems = document.querySelectorAll(".nav a");

export function mainNav() {

    bindEvents();
    setNav();
    setupLogoInteraction();

    //
    const heroVideo = document.getElementById('background-video');
    if (heroVideo) heroVideo.pause();
}

const bindEvents = () => {
    const navLinks = document.querySelectorAll(".nav li a.link");
    const xClose = document.querySelector(".close-icon-container .x-close");
    const navIcon = document.querySelector(".nav-icon-container");

    // Set link items
    navLinks.forEach(link => {

        link.addEventListener("click", (evt) => {
            evt.preventDefault();

            let targetSection = link.getAttribute("data-nav");

            const bodyId = document.body.id;
            if (bodyId == "home") {
                const homeTarget = document.querySelector(".home-" + targetSection);

                if (targetSection == "hero-video") {
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });

                } else {
                    scrollTo(homeTarget);
                }

            } else {
                goToHomeSection(targetSection);
            }

            xClose.click();
        })
    })

    // Open nav overlay
    navIcon.addEventListener("click", (evt) => {
        evt.preventDefault();

        let navX = isMobile() && isPortrait() ? 25 : 50;

        gsap.to(".nav-icon-container", { top: 50, duration: 0.35, ease: "circ.inOut" });
        gsap.to(".nav-overlay", { right: navX, duration: 0.35, ease: "circ.inOut" });
        gsap.fromTo(".x-close", { top: 50 }, { top: 8, delay: 0.15, duration: 0.65, ease: "circ.Out" });
    });

    // Close nav overlay
    xClose.addEventListener("click", (evt) => {
        evt.preventDefault();
        gsap.to(".nav-icon-container", { top: 0, duration: 0.35, ease: "circ.inOut" });
        gsap.to(".nav-overlay", { right: -600, duration: 0.35, ease: "circ.inOut" });
    });
}

const scrollTo = (homeTarget) => {

    console.log('+++ homeTarget: ', homeTarget);

    setTimeout(() => {
        homeTarget.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
        });
    }, 350);

    const hasParams = window.location.search.length > 1;
    if (hasParams) {
        clearParms();
    }
}

const clearParms = () => {
    window.history.replaceState(null, '', window.location.pathname + window.location.hash);
}

const goToHomeSection = (homeTarget) => {

    const bodyElement = document.body;
    let pID = bodyElement.getAttribute("id");

    if(pID !== homeTarget) {
        location.href = "/?section=" + homeTarget;
    }
}

const isMobile = () => {
    const isMobile = document.documentElement.classList.contains('mobile');
    return isMobile;
}

const isPortrait = () => {
    const isPortrait = document.documentElement.classList.contains('portrait');
    return isPortrait;
}

const setNav = () => {

    let navW = isMobile() && isPortrait() ? "90%" : 600;
    gsap.set(".nav-overlay", { width: navW });

    const bodyElement = document.body;
    let pID = bodyElement.getAttribute("id");

    if(pID != "home") {
        document.querySelector(`.nav-${pID}`).classList.add("active");
    }
}

const setupLogoInteraction = () => {

    const heroVideo = document.getElementById('background-video');

    ScrollTrigger.create({
        start: window.innerHeight - 50,
        onEnter: ({ direction }) => {
            if (heroVideo) heroVideo.pause();
            gsap.set(heroVideo, { opacity: 0 });
            //console.log('onEnter');
        },
        onLeaveBack: ({ direction }) => {
            if (heroVideo) heroVideo.play();
            gsap.set(heroVideo, { opacity: 0.4 });
            //console.log('onLeaveBack');
        },
        markers: false
    })
}